export default "skymp5-front/79a2d684ce0ce231b4fc4ae00462abbd.svg";